<p-dialog [(visible)]="displayPastListsDialog" [focusOnShow]="false" [style]="{width: '620px'}"
          dismissableMask="true"
          header="Download past symbol lists" modal="true">
  <div *ngIf="researchForm" [formGroup]="researchForm">
    <p>Select a range of dates and click 'Download'. Only dates with a published symbol list are selectable.</p>
    <div class="past-range-controls">
      <label class="mb-0" for="past_date_filter_range_1">From date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange1"
        id="past_date_filter_range_1"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
      <label class="mb-0" for="past_date_filter_range_2">To date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange2"
        id="past_date_filter_range_2"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="resetRangeDates()"
            icon="fa fa-refresh pr-2"
            iconPos="left"
            label="Reset"
            pButton
            type="button"></button>
    <button (click)="downloadQrdSymbolsWithThisDateRange()"
            [disabled]="rangeDateNotSelected()"
            icon="fa fa-download pr-2"
            iconPos="left"
            id="download_past_file_with_date_range_button"
            label="Download"
            pButton
            type="button"></button>
  </ng-template>
</p-dialog>
<div class="layout-main">
  <div class="container-fluid">
    <div class="symbols-title-row">
      <h3 class="mb-0">
        <b>{{ newsOnly ? 'Quincy News: symbols' : 'Raw: symbols' }}</b>
      </h3>
      <div class="symbols-title-meta">
        <span *ngIf="qrdSymbolsInfo?.updatedAt">Updated
          on: {{ qrdSymbolsInfo?.updatedAt | date: 'yyyy-MM-dd H:mm:ss' }}</span>
      </div>
    </div>
    <div *ngIf="alertQedSymbolHasNotChanged" class="alert alert-danger alert-dismissible fade show">
      This information is outdated. Please verify that the {{ newsOnly ? 'Quincy News' : 'QRD' }} symbol list has not
      changed.
    </div>
    <div *ngIf="!alertQedSymbolHasNotChanged && researchForm" [formGroup]="researchForm">
      <div class="symbols-filter">
        <label class="symbols-filter-label mb-0" for="qrd_product_filter">Product</label>
        <p-dropdown (onChange)="filteredQrdSymbolList()"
                    [filter]="true"
                    [options]="qrdProductDropdown"
                    [showClear]="true"
                    formControlName="qrdProduct"
                    id="qrd_product_filter"
                    placeholder="All products"></p-dropdown>
        <label class="symbols-filter-label mb-0" for="channel_filter">Channel</label>
        <input (input)="filteredQrdSymbolList()" class="form-control symbols-filter-input" formControlName="channel"
               id="channel_filter" placeholder="Filter…" type="text">
        <label class="symbols-filter-label mb-0" for="description_filter">Description</label>
        <input (input)="filteredQrdSymbolList()" class="form-control symbols-filter-input"
               formControlName="description"
               id="description_filter" placeholder="Filter…" type="text">
        <div class="symbols-filter-right">
          <button (click)="downloadMenu.toggle($event)" icon="fa fa-download pr-2" iconPos="left"
                  id="download_csv_menu_button" label="Download CSV" pButton type="button"></button>
          <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="reset_button"
                  label="Reset" pButton type="button"></button>
        </div>
      </div>
      <p-overlayPanel #downloadMenu styleClass="sym-download-menu">
        <div class="symbols-menu">
          <button (click)="downloadCurrentQrdSymbolList(); downloadMenu.hide()" class="symbols-menu-item"
                  id="download_current_qrd_symbol_list" type="button">
            <i aria-hidden="true" class="fa fa-download"></i>This week's symbol list
          </button>
          <ng-container *ngIf="startDates">
            <div class="symbols-menu-sep"></div>
            <button (click)="displayPastListsDialog = true; downloadMenu.hide()" class="symbols-menu-item"
                    id="past_lists_menu_item" type="button">
              <i aria-hidden="true" class="fa fa-calendar"></i>Past symbol lists…
            </button>
          </ng-container>
        </div>
      </p-overlayPanel>
      <div>
        <div *ngIf="noDataToDisplay()">
          <h3 class="symbols-no-data">No data for this week, please select another date</h3>
        </div>
        <div *ngFor="let market of marketList">
          <div *ngIf="qrdSymbolList(market).length !== 0" class="symbols-market-table">
            <p-table (sortFunction)="tableService.customSort($event)" [columns]="cols" [customSort]="true"
                     [rowHover]="true" [rowTrackBy]="trackByFn"
                     [tableStyle]="{'table-layout':'auto'}" [value]="qrdSymbolList(market)" id="companies-list-table">
              <ng-template pTemplate="caption">
                {{ market }} <span class="symbols-table-count">{{ qrdSymbolList(market).length }} symbols</span>
              </ng-template>
              <ng-template let-columns pTemplate="header">
                <tr>
                  <th *ngFor="let col of cols">
                    {{ col.header }}
                  </th>
                </tr>
              </ng-template>
              <ng-template let-qrdSymbol pTemplate="body">
                <tr>
                  <td>{{ qrdSymbol.marketName }}</td>
                  <td>{{ getQrdQpdProductName(qrdSymbol) }}</td>
                  <td style="padding: 0">
                    <button (click)="redirectionToQrdMulticastListWithChannelGetParameter(qrdSymbol.market)"
                            class="btn btn-link">{{ qrdSymbol.market }}
                    </button>
                  </td>
                  <td>{{ qrdSymbol.type }}</td>
                  <td>{{ htmlDecode(qrdSymbol.name) }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div *ngIf="sfiSymbolList().length > 0" class="symbols-market-table">
          <p-table
            [columns]="cols"
            [value]="sfiSymbolList()"
            [rowHover]="true"
            [tableStyle]="{'table-layout':'auto'}">
            <ng-template pTemplate="caption">
              SFI channels <span class="symbols-table-count">{{ sfiSymbolList().length }} symbols</span>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>{{ rowData.marketName }}</td>
                <td>{{ getQrdQpdProductName(rowData) }}</td>
                <td>{{ rowData.sfiPermissioningId }}</td>
                <td>{{ rowData.type }}</td>
                <td>{{ htmlDecode(rowData.name) }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="symbols-footer">
          <button [routerLink]="newsOnly ? '/quincy-news-symbols/multicast' : '/qrd-symbols/multicast'"
                  class="btn btn-link symbols-footer-link">
            See the Multicast IP list.
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
